import { type BaseQLSelectionSet, selectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { Adresse } from '@martinus/address/entities/Adresse.js';
import { BillingPosition } from '../../billingPositions/entities/BillingPosition.js';
import type { Group } from './Group.js';
import type { Kostenstelle, KostenstelleSubGroup } from './Kostenstelle.js';
import type { School } from './School.js';

const materializedParentGroupSelectionset: BaseQLSelectionSet<Group & School & Kostenstelle & KostenstelleSubGroup> = {
  /**
   * Group fields
   */
  name: 1,
  kuerzel: 1,
  parentIDs: 1,
  iban: 1,
  billingLockStichtag: 1,
  billingLockReleaseDay: 1,
  billingPosition: selectionSet(() => BillingPosition, 1),

  /**
   * School fields
   */
  imageID: 1,
  diputatsstunden: 1,
  isSgSchool: 1,
  bundesland: 1,
  kostenstellePrefix: 1,
  accountingNumber: 1,
  microsoftDomain: 1,
  telefonNr: 1,
  schulnummer: 1,
  homepageURL: 1,
  linkGanztagsangebotInfo: 1,
  schoolType: 1,
  abwesenheitsemail: 1,
  infoMail: 1,
  susBewerbungReplyTo: 1,
  addBGMail: 1,
  adresse: selectionSet(() => Adresse, 1),
  publicSchool: 1,
  mode: 1,

  /**
   * Kostenstelle fields
   */
  kostenstelleSuffix: 1,
};

export const materializedGroupSelectionset = () => {
  const sel: BaseQLSelectionSet<Group & School & Kostenstelle & KostenstelleSubGroup> = {
    ...materializedParentGroupSelectionset,
    parents: materializedParentGroupSelectionset,
    school: materializedParentGroupSelectionset,
    kostenstelle: materializedParentGroupSelectionset,
  };
  return sel;
};
